import type { MomentsSessionTranscriptSummary } from '@/store/api/momentsApi';

import { formatDateLabel, toDateSlug } from '@/utils/dateSlug';

const fallbackTranscriptDateSlug = 'transcript';

export const toTranscriptDateSlug = (
  value: string | null | undefined,
): string => toDateSlug(value, fallbackTranscriptDateSlug);

export const formatTranscriptDateLabel = (
  value: string | null | undefined,
): string | undefined => formatDateLabel(value, [fallbackTranscriptDateSlug]);

export const buildMemberSessionTranscriptPath = ({
  dateSlug,
  sessionDate,
  sessionId,
}: {
  dateSlug?: string | null;
  sessionDate?: string | null;
  sessionId: string | null | undefined;
}): string | null => {
  const trimmedSessionId = sessionId?.trim();
  if (!trimmedSessionId) {
    return null;
  }
  return `/m/session/${encodeURIComponent(
    trimmedSessionId,
  )}/transcript/${encodeURIComponent(
    dateSlug?.trim() || toTranscriptDateSlug(sessionDate),
  )}`;
};

export const readyTranscriptItems = (
  items: MomentsSessionTranscriptSummary[],
): MomentsSessionTranscriptSummary[] =>
  items.filter(
    (item) =>
      item.contentStatus === 'ready' && Boolean(item.contentMarkdown?.trim()),
  );

// The transcripts API returns only the transcript part of each file, the same
// text artifact generation reads, so the page shows it as it is (MEN-5254).
export const concatenateTranscriptMarkdown = (
  items: MomentsSessionTranscriptSummary[],
): string =>
  readyTranscriptItems(items)
    .map((item) => item.contentMarkdown?.trim() ?? '')
    .join('\n\n');
